import styles from './BrandInviteStatus.module.scss'
import MeritoDarkLogo from "../../assets/images/MeritoDarkLogo.webp";
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { RiCheckboxCircleFill as SuccessIcon } from 'react-icons/ri'
import { MdOutlineWatchLater as ExpiredIcon } from 'react-icons/md'

enum InviteStatus {
  success = 'success',
  expired = 'expired',
}

const BrandInviteStatus = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState<InviteStatus>(null);
  const [agencyName, setAgencyName] = useState<string>(null);

  useEffect(() => {
    const state = searchParams.get('state');
    const agencyName = searchParams.get('agencyName');
    if (state == InviteStatus.success) {
      setState(InviteStatus.success);
    } else if (state == InviteStatus.expired) {
      setState(InviteStatus.expired);
    }
    if (agencyName) {
      setAgencyName(agencyName);
    }

  }, [])

  return (
    <div className={styles.rootContainer}>
      <div className={styles.header}>
        <div className={styles.brandLogo}>
          <img
            src={MeritoDarkLogo}
            alt="brnadlogo"
            className="img-fluid"
          />
        </div>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.statusRootContainer}>
          <div className={`${styles.iconContainer} ${state === InviteStatus.success ? styles.success : styles.expired}`}>
            {state === InviteStatus.success ?
              <SuccessIcon />
              : <ExpiredIcon />}
          </div>

          <div className={styles.title}>
            {state === InviteStatus.success ? 'Thanks for Confirming!' : 'Link Expired!'}
          </div>
          <div className={styles.subText}>
            {state === InviteStatus.success ?
              <>
                <b>{agencyName}</b> will continue from here. <br />
                We’ll let you know once everything’s ready.
              </> :
              <>Please ask your agency to resend the invitation.</>}
          </div>
          {state == InviteStatus.success ? <div className={styles.subText}>
            To learn more about Merito, visit <a href="https://clickmerito.com" target='_blank'>clickmerito.com</a>
          </div> : null}
        </div>
      </div>
    </div>
  );
}

export default BrandInviteStatus;